<div class="ir-row">
  <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
    <p>
      <span
        ><strong>{{ 'plugins.installation-inspection-info.start-date' | translate }}</strong></span
      >
    </p>
  </div>
  <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
    <p>
      <span>{{ config?.StartDate | formatDate }}</span>
    </p>
  </div>
</div>
<div class="ir-row">
  <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
    <p>
      <span
        ><strong>{{ 'plugins.installation-inspection-info.end-date' | translate }}</strong></span
      >
    </p>
  </div>
  <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
    <p>
      <span>{{ config?.EndDate | formatDate }}</span>
    </p>
  </div>
</div>
<!-- <div class="ir-row">
  <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
    <p>
      <span
        ><strong>{{ 'plugins.installation-inspection-info.intervention-type' | translate }}</strong></span
      >
    </p>
  </div>
  <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
    <p>
      <span>{{ config?.InterventionType | subType }}</span>
    </p>
  </div>
</div> -->
